module.exports = __webpack_public_path__ + "img/toast-success.8f954ed2.svg";